import React from 'react';
import { Box, Button, Heading } from '@apia/theme';
import { useAppSelector } from '../../../../../hooks/hooks';
import store from '../../../../../store';
import { responsiveTableActions } from '../../../../../store/responsiveTableSlice';
import { IAccordionElementButton } from '../../../AccordionElementButton';
import Checkbox from '../../../fields/Checkbox';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { TAccordionCellButtonRenderer } from './AccordionCell';
import { TResponsiveTableRow } from '../types';

const AccordionElementButton: TAccordionCellButtonRenderer = ({
  expandedIcons,
  id,
  isExpanded,
  onClick,
  rowIndex,
  title,
  children,
}) => {
  const { name } = useResponsiveTableContext();
  const isSelected = useAppSelector((global) =>
    global.responsiveTableSlice[name]?.selectedRows.includes(rowIndex),
  );
  return (
    <Box className="responsiveTable__accordionElement__toggler">
      <Checkbox
        className="accordionElement__toggler__checkbox"
        checked={isSelected}
        aria-labelledby={`section_${id}`}
        onChange={React.useCallback<
          React.ChangeEventHandler<HTMLInputElement>
        >(() => {
          store.dispatch(
            responsiveTableActions.updateByClick({
              id: name,
              ariaRowIndex: rowIndex,
              ctrlKey: true,
              altKey: false,
              colIndex: 0,
              shiftKey: false,
            }),
          );
        }, [name, rowIndex])}
      />
      <Button
        aria-label={title}
        aria-expanded={isExpanded}
        aria-controls={`${id}_content`}
        id={`section_${id}`}
        title={title}
        {...window.getVariant('inherit')}
        type="button"
        onClick={onClick}
        className="accordionElement__toggler__button"
      >
        <Heading as="h3" className="accordionElement__toggler__label">
          {children ?? title}
        </Heading>
        <Box className="accordionElement__toggler__expandIcon">
          {expandedIcons}
        </Box>
      </Button>
    </Box>
  );
};

export interface IMakeAccordionElementButton {
  rowIndex: number;
  row: TResponsiveTableRow;
}

export default function makeAccordionElementButton({
  rowIndex,
  row,
}: IMakeAccordionElementButton) {
  return React.memo((props: IAccordionElementButton) => {
    return <AccordionElementButton {...props} row={row} rowIndex={rowIndex} />;
  });
}
